export type Tag = {
  tag_id?: string;
  name: string;
  type: string;
};

export enum SPECIAL_TAGS {
  QUICK_ACCESS = "QuickAccess",
  ADMIN_ONLY_CONTENT = "ADMIN_ONLY_CONTENT",
}

export const TAG_TYPE_ORG_EXCLUSIVE = "org_exclusive";
export const TAG_TYPE_DOMAIN = "domain";
export const TAG_TYPE_SYSTEM = "system";

export function getOrgExclusiveTagName(orgName: string): string {
  return `OrgExclusive:${orgName}`;
}

export function isAdminOnlyContentTag(tag?: Pick<Tag, "name"> | null): boolean {
  return tag?.name === SPECIAL_TAGS.ADMIN_ONLY_CONTENT;
}
